export const route = Object.freeze({
  biometrics: 'biometrics',
  bulkAddAndEdit: 'bulk-add-and-edit',
  clockPrompts: 'clock-prompts',
  hardwareClocks: 'hardware-clocks',
  companyInfo: 'company-info',
  dashboard: 'dashboard',
  deductions: 'deductions',
  employeeInvites: 'employee-invites',
  employeeRecord: 'employee-record',
  employeesList: 'employees-list',
  employeeTypes: 'employee-types',
  finalizePayPeriod: 'finalize-pay-period',
  geofence: 'geofence',
  groups: 'groups',
  groupManagement: 'group-management',
  integrations: 'integrations',
  organizationChart: 'organization-chart',
  organizationSetup: 'organization-setup',
  payrollExport: 'payroll-export',
  people: 'people',
  punchCategories: 'punch-categories',
  schedule: 'schedule',
  employeeSchedule: 'employeeSchedule',
  employeeOpenShifts: 'employeeOpenShifts',
  shiftSwaps: 'shiftSwaps',
  settingsSchedule: 'settings-schedule',
  settingsTimecard: 'settings-timecard',
  settingsTimeclock: 'settings-timeclock',
  settingsBreaksMeals: 'settings-break-and-meals',
  settingsTimeoff: 'settings-timeoff',
  settingsOvertime: 'settings-overtime',
  settingsHolidays: 'settings-holidays',
  settings: 'settings',
  timeCard: 'timecard',
  timeCardDaily: 'timecard-daily',
  timeOff: 'timeoff',
  myTimeOff: 'myTimeOff',
  timeReports: 'time-reports',
  timeui: 'timeui',
  partnerHardwareClocks: 'partner-hardware-clocks',
  partnerIntegration: 'partner-integration',
  partnerProducts: 'products',
  partnerPricing: 'pricing',
  partnerFGAdmin: 'fg-admin',
  companies: 'companies',
  supportCenter: 'support-center',
  marketingContent: 'marketing-content',
  partnerUserManagement: 'user-management',
  twpPortal: 'twp-portal',
  accruals: 'accruals',
  generalInfo: 'general-info',
  essSettings: 'ess-settings',
  onboardSettings: 'onboard-settings',
  documentSettings: 'document-settings',
  unmatchedPunches: 'unmatched-punches',
  logins: 'logins',
  multiCompanyAssignment: 'multi-company-assignment',
  updatePersonalInfo: 'update-personal-info',
  resetPartnerPassword: 'reset-password',
  suggestionBox: 'suggestion-box',
  companyMessages: 'company-messages',
  companyDocsAndLinks: 'company-docs-links',
  billing: 'billing',
  inAppBilling: 'in-app-billing',
  trialAdmin: 'trial-admin',
  credmgmt: 'credmgmt',
  peopleTabAccess: 'people-tab-access',
});

export const target = Object.freeze({
  self: 'self',
  blank: 'blank',
  // Open the link in shell window (redirecting outside
  // of shell-ui).
  same: 'same',
});

// We are hard coding routes here for incoming requests
export const navigationRequests = Object.freeze({
  [route.integrations]: '/admin/integrations',
});

export const partnerNavigationRequests = Object.freeze({
  [route.integrations]: '/companies/company-integrations',
});
